import makeStyles from "@mui/styles/makeStyles";

export const useBrickEditorStyles = makeStyles({
  brickEditor: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    minHeight: '400px'
  }
});